export const getUrlParams = () => {
  const query = window.location.search.substring(1);
  return query
    .split("&")
    .map((val) => val.split("="))
    .reduce((p, v) => {
      if (v.length === 2) {
        p[v[0]] = v[1];
      }
      return p;
    }, {});
};
